module.exports = __webpack_public_path__ + "img/6-insurance-zone-personal.7e64d326.jpg";